import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import { ModalBody, ModalFooter, ModalHeader, ModalTransition } from '@atlaskit/modal-dialog';
import { token } from '@atlaskit/tokens';
import { JiraModal as Modal } from '@atlassian/jira-modal/src/ui/jira-modal.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { messages } from './messages.tsx';

export type Props = {
	isOpen: boolean;
	onConfirm: () => void;
	onCancel: () => void;
};

export const RemoveFormConfirmationDialog = ({ isOpen, onConfirm, onCancel }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<ModalTransition>
			{isOpen && (
				<Modal
					messageId="project-settings-product-features-jsm-common.ui.form-panel.form-card.remove-form-confirmation.modal.modal-dialog"
					messageType="transactional"
					onClose={onCancel}
				>
					<ModalHeader>
						<HeaderWrapper>
							<WarningIcon spacing="spacious" color={token('color.icon.warning')} label="" />
							<WarningText>{formatMessage(messages.title)}</WarningText>
						</HeaderWrapper>
					</ModalHeader>
					<ModalBody>
						{fg('itsm-issue-renaming')
							? formatMessage(messages.descriptionIssueTermRefresh)
							: formatMessage(messages.description)}
					</ModalBody>
					<ModalFooter>
						<Button
							appearance="subtle"
							onClick={onCancel}
							autoFocus={false}
							aria-label={formatMessage(messages.cancelButton)}
						>
							{formatMessage(messages.cancelButton)}
						</Button>
						<Button
							appearance="warning"
							onClick={onConfirm}
							autoFocus={false}
							aria-label={formatMessage(messages.removeButton)}
						>
							{formatMessage(messages.removeButton)}
						</Button>
					</ModalFooter>
				</Modal>
			)}
		</ModalTransition>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderWrapper = styled.h3({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WarningText = styled.span({
	marginLeft: token('space.100'),
});
